// import moment from 'moment'
import NOAATides from '../services/NOAATides'

import {
  REQUEST_USER_LOCATION,
  RECIEVE_USER_LOCATION,
  RECIEVE_USER_LOCATION_ERROR
} from './'

import {
  userLocationSelector,
} from '../reducers/userLocationReducer'

import {
  selectTideStation,
  updateLocationSearch,
} from './uiActions'


export const USER_LOCATION_ERRORS = {
  PERMISSION_DENIED:    'PERMISSION_DENIED',
  POSITION_UNAVAILABLE: 'POSITION_UNAVAILABLE',
  TIMEOUT:              'TIMEOUT'
}






// ===================
// = Action Creators =
// ===================

function requestUserLocation() {
  return {
    type: REQUEST_USER_LOCATION
  }
}

function recieveUserLocation(coords, station, lastUpdated) {
  return {
    type: RECIEVE_USER_LOCATION,
    payload: {
      coords,
      station,
      lastUpdated,
    }
  }
}

function recieveUserLocationError(error) {
  return {
    type: RECIEVE_USER_LOCATION_ERROR,
    error,
  }
}







// =======================
// = Fetch user location =
// =======================

// Wrap geolcation in Promise generator
function getCurrentPosition(options) {
  const promise = new Promise(function(resolve, reject) {
    navigator.geolocation.getCurrentPosition(resolve, reject, options)
  })
  return promise
}

const geolocationOptions = {
  timeout: 10000,
  enableHighAccuracy: false
}

const GEOLOCATION_ERROR_CODES = {
  1: 'PERMISSION_DENIED',
  2: 'POSITION_UNAVAILABLE',
  3: 'TIMEOUT'
}

function fetchUserLocation() {
  return function(dispatch) {

    // Update state to indicate fetching
    dispatch(requestUserLocation())

    // Get current position
    return getCurrentPosition(geolocationOptions)
    .then(

      // Success
      (position) => {
        const coords = {
          accuracy: position.coords.accuracy,
          latlng: {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
        }

        const station = NOAATides.getClosestStation(coords.latlng)

        return dispatch(recieveUserLocation(
          coords,
          station,
          position.timestamp
        ))
      },

      // Error
      (positionError) => {
        dispatch(recieveUserLocationError(
          GEOLOCATION_ERROR_CODES[positionError.code]
        ))
        return Promise.reject(positionError)
      }
    )
  }
}

export function fetchUserLocationIfNeeded() {
  return function(dispatch, getState) {
    const state = getState()
    const userLocation = userLocationSelector(state)

    // Don't fetch if currently fetching
    if (userLocation.isFetching) {
      return Promise.reject({
        status: 'FETCHING',
        message: "Fetching is already underway"
      })
    }

    // Otherwise fetch location
    return dispatch(fetchUserLocation())
  }
}

export function findAndSelectClosestTideStation() {
  return function(dispatch, getState) {
    return dispatch(fetchUserLocationIfNeeded())
    .then(function() {
      const state = getState()
      const userLocation = userLocationSelector(state)
      const station = userLocation.station
      dispatch(selectTideStation(station))
      dispatch(updateLocationSearch({query: station.name}))
    })
  }
}






window.requestUserLocation = requestUserLocation
window.fetchUserLocation = fetchUserLocation
window.fetchUserLocationIfNeeded = fetchUserLocationIfNeeded
window.findAndSelectClosestTideStation = findAndSelectClosestTideStation



// WEBPACK FOOTER //
// ./src/actions/userLocationActions.js